import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalLogisticFilter = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;

  const isOpen = getModal('single.filterLogistic');

  const onClose = () => {
    closeSingleModal('filterLogistic');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de logística'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Export.Logistic.Filter />
    </Modal>
  );
};

export default ModalLogisticFilter;
